var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteVFlourish(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 48,
    viewBox: "0 0 46 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_310_231)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.6573 5.28456L41.9581 3.65855L40.2671 2.91058L41.9581 2.17887L42.6573 0.634155L43.3565 2.17887L45.0476 2.91058L43.3565 3.65855L42.6573 5.28456ZM42.6573 14.9594L41.9581 13.3984L40.2671 12.6667L41.9581 11.935L42.6573 10.2927L43.3565 11.935L45.0476 12.6667L43.3565 13.3984L42.6573 14.9594ZM35.5191 12.4553L34.0232 9.25204L30.7549 7.78863L34.0232 6.32521L35.5191 3.13822L37.0313 6.32521L40.2833 7.78863L37.0313 9.25204L35.5191 12.4553Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8397 30.1045C15.3868 30.1045 13.3798 29.324 11.8188 27.763C10.2578 26.2021 9.47735 24.1951 9.47735 21.7421C9.47735 19.2892 10.2578 17.2822 11.8188 15.7212C13.3798 14.1602 15.3868 13.3798 17.8397 13.3798C20.2927 13.3798 22.2997 14.1602 23.8606 15.7212C25.4216 17.2822 26.2021 19.2892 26.2021 21.7421C26.2021 24.1951 25.4216 26.2021 23.8606 27.763C22.2997 29.324 20.2927 30.1045 17.8397 30.1045ZM0 48V42.7596C0 41.3472 0.353078 40.1393 1.05923 39.1359C1.76539 38.1324 2.67596 37.3705 3.79094 36.8501C6.28107 35.7352 8.66899 34.8989 10.9547 34.3414C13.2404 33.7839 15.5354 33.5052 17.8397 33.5052C20.144 33.5052 22.4297 33.7932 24.6969 34.3693C26.964 34.9454 29.3426 35.7723 31.8328 36.8501C32.9849 37.3705 33.9141 38.1324 34.6202 39.1359C35.3264 40.1393 35.6794 41.3472 35.6794 42.7596V48H0Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_310_231"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.6098,
    height: 15.6098,
    fill: "white",
    transform: "translate(30.1045)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteVFlourish);
export default __webpack_public_path__ + "static/media/whiteVFlourish.4c2e914646a7b5d9cd6d89de200f5554.svg";
export { ForwardRef as ReactComponent };